import { render, staticRenderFns } from "./Eye.vue?vue&type=template&id=025b59ea&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Eye.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/Eye.vue
// module id = 2297
// module chunks = 1